export default {
  cerrarSesion: {
    text: "Cerrar Sesión"
    , swal: {
      title: "Cerrar Sesión"
      , text: "Puede mejorar la seguridad cerrando el navegador una vez que ha salido del sistema"
    }
  }
  , perfilUsuario: { text: "Perfil" }
  , footer: {
    copyRight: "Nexion Solutions S.A de C.V. © 2021"
    , sistema: "ACH - American Express Canales"
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/home.js